import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { readRemoteFile } from "react-papaparse";
import "./App.css";

const useStyles = makeStyles({
  root: {
    maxWidth: 600
  },
  quote: {
    color: "#999",
    fontSize: 25
  },
  author: {
    fontSize: 50
  }
});

function App() {
  const classes = useStyles();
  const [quote, setQuote] = useState(null);

  useEffect(() => {
    const url =
      "https://raw.githubusercontent.com/akhiltak/inspirational-quotes/master/Quotes.csv";

    readRemoteFile(url, {
      complete: function(results) {
        console.log("Results:", results);
        const items = results.data;
        const quote = items[Math.floor(Math.random() * items.length)];
        console.log("Random", quote);
        setQuote(quote);
      },
      skipEmptyLines: true
    });
  }, []);

  if (quote == null) {
    return false;
  }

  return (
    <div className="App">
      <header className="App-header">
        <Card raised className={classes.root}>
          <CardActionArea>
            <CardContent>
              <blockquote
                variant="body2"
                color="textSecondary"
                component="p"
                className={classes.quote}
              >
                "{quote[0]}"
              </blockquote>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                className={classes.author}
              >
                {quote[1]}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </header>
    </div>
  );
}

export default App;
